export default [
    // 学业评价-报名选课列表
    {
        path: "xypj/apply-curricula-variable-list",
        name: "ApplyCurriculaVariableList",
        component: () =>  import('./ApplyCurriculaVariableList.vue')
    },
    // 学业评价-学习进度管理
    {
        path: "xypj/learning-progress-list",
        name: "LearningProgressList",
        component: () =>  import('./LearningProgressList.vue')
    },
    // 学业评价-学习进度统计
    {
        path: "xypj/learning-progressTj-list",
        name: "LearningProgressTjList",
        component: () =>  import('./LearningProgressTjList.vue')
    },
    // 学业评价-学生观看情况
    {
        path: "xypj/student-watch-condition-list",
        name: "StudentWatchConditionList",
        component: () =>  import('./StudentWatchConditionList.vue')
    },
    // 学业评价-作业列表
    {
        path: "xypj/regular-assignment-list",
        name: "RegularAssignmentList",
        component: () =>  import('./RegularAssignmentList.vue')
    },
    // 学业评价-作业已做记录
    {
        path: "xypj/regular-assignment-accomplish-list",
        name: "RegularAssignmentAccomplishList",
        component: () =>  import('./RegularAssignmentAccomplishList.vue')
    },
    // 学业评价-作业未做记录
    {
        path: "xypj/regular-assignment-unfinished-list",
        name: "RegularAssignmentUnfinishedList",
        component: () =>  import('./RegularAssignmentUnfinishedList.vue')
    }
];






